import util from '@/libs/util';
import router from '@/router';
import {
	listMenuTreemManage,
	listMenuTreemManageInit,
	listMenuTreemManageByAuthorizations,
	deleteMenuTreemManage
	
} from '@api/systemmanage/MenuTreemManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listMenuTreemManage({
			state
		}) {
			return new Promise((resolve, reject) => {
				listMenuTreemManage(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listMenuTreemManageByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				state.AdvanceQuery.entity.parentMenuId="root";
				listMenuTreemManageByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listMenuTreemManageInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				state.AdvanceQuery.entity.parentMenuId="root";
				listMenuTreemManageInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteMenuTreemManage({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteMenuTreemManage({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
